import CustomMidwayClient from '../../../client/CustomMidwayClient';
import { getAsinMetricsEndpointConfig } from './asin-metrics-endpoint-configs';

export default class MidwayClient {
  asinMetricsClient;

  constructor() {
    const endpointConfigs = getAsinMetricsEndpointConfig();
    this.asinMetricsClient = new CustomMidwayClient(endpointConfigs);
  }
}


// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/midway_client.jsx